import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  kitSKU: {
    name: "kitSKU",
    label: "Kit SKU",
    type: "text",
    editable: false,
    required: true,
    maxLength: 50,
    xs: 3,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 3,
  },
  kitName: {
    type: "text",
    name: "kitName",
    label: "Kit Name",
    maxLength: 100,
    required: true,
    xs: 3,
  },
  sellingPrice: {
    type: "number",
    name: "sellingPrice",
    label: "Selling Price",
    errorMsg: "Selling Price is required",
    errorMsg2: "Selling Price must be greater than 0",
    xs: 3,
  }
};

const { kitSKU, customerCode, kitName, sellingPrice } = formField;

export const formRender = [[kitSKU, kitName, sellingPrice, customerCode]];

export const initialValues = getInitialValues(formField);

export const kitSKUValidation = Yup.object().shape({
  [kitSKU.name]: Yup.string().nullable().max(kitSKU.maxLength).required(kitSKU.errorMsg),
  [kitName.name]: Yup.string().nullable().max(kitName.maxLength),
  [sellingPrice.name]: Yup.number().min(0, sellingPrice.errorMsg2).typeError(sellingPrice.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
});
